package org.example.site_web.content

import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

data class OfferContent(val title: String, val content: String)


val ourOfferContentMap = mapOf(
    "GENERAL" to OfferContent("Multi-disciplinarité" ,"Notre proposition est généraliste et combine les sciences de l’ingénieur,"+
            " l’électronique et l’informatique pour permettre une maîtrise complète et une personnalisation optimale des projets."),

    "ANALYSE" to OfferContent("Analyse étendue" ,"Une analyse de vos sujets englobant réflexion scientifique, solutions technologiques et analyse des facteurs humains et organisationnels."+
            "\r\nNous construisons les projets et les travaux autour du retour sur investissement attendu par votre structure pour assurer la rentabilité."),

    "LOOK" to OfferContent("Regard expert","Accelarge Innovations ce sont des conseils et des propositions basés sur une expérience large et variée dans l’industrie et les projets techniques.."+
    "\r\nC’est également un regard objectif et pragmatique sur vos idées tout en restant passionné par la recherche de solutions.")
)
